import { ConfigProvider, Loader } from '@repo/go-ui';
import { useEffect, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { removeTokens } from 'src/services/auth-service/auth';

export const LogoffPage: FC = () => {
  const { t } = useTranslation('common');

  useEffect(() => {
    try {
      removeTokens();
    } catch {
      // ignore storage errors during logoff cleanup
    }

    window.location.replace('/');
  }, []);

  return (
    <ConfigProvider
      config={{
        theme: 'dark',
        style: 'bordered',
        size: 's',
      }}
      externalElement={document.body}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100vh',
        }}
      >
        <Loader size="l" />
        <div
          style={{
            position: 'absolute',
            left: '50%',
            top: 'calc(50% + 48px)',
            transform: 'translateX(-50%)',
            zIndex: 1,
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 600,
            color: 'var(--go-text)',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          {t('signingOut')}
        </div>
      </div>
    </ConfigProvider>
  );
};
